import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { EmojiPicker } from 'frimousse';
import { forNotoEmoji } from './clueUtils';

const MAX_WIDTH = 840;
const TARGET_CELL = 64;   // desired button size; columns are fitted to the dialog width

// Columns and button size that fill the dialog at the current window width.
const layoutFor = (vw) => {
  const inner = Math.min(MAX_WIDTH, vw - 24) - 16;
  const columns = Math.max(5, Math.floor(inner / TARGET_CELL));
  return { columns, cell: Math.floor(inner / columns) };
};

// Emojis render in Noto Emoji like the clue preview, so presentation selectors are
// dropped (forNotoEmoji) or Chrome would draw some of them with the system color font.
const EmojiButton = ({ emoji, ...props }) => (
  <button type="button" {...props} className="emoji-btn">{forNotoEmoji(emoji.emoji)}</button>
);
const CategoryHeader = ({ category, ...props }) => <div {...props} className="emoji-cat">{category.label}</div>;
const Row = (props) => <div {...props} className="emoji-row" />;

const EmojiPickerDialog = ({ onSelect, onClose }) => {
  const [layout, setLayout] = useState(() => layoutFor(window.innerWidth));

  useEffect(() => {
    const onResize = () => setLayout(layoutFor(window.innerWidth));
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('resize', onResize);
    document.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('resize', onResize);
      document.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="emoji-overlay" onClick={onClose}>
      <div className="emoji-dialog" style={{ '--emoji-cell': `${layout.cell}px` }}
        onClick={e => e.stopPropagation()} role="dialog" aria-label="Insert emoji">
        <EmojiPicker.Root onEmojiSelect={e => onSelect(e.emoji)} columns={layout.columns} className="emoji-root"
          style={{ '--frimousse-emoji-font': '"Noto Emoji", sans-serif' }}>
          <div className="emoji-head">
            <EmojiPicker.Search placeholder="Search emoji..." className="emoji-search" />
            <button type="button" className="emoji-close" onClick={onClose} aria-label="Close">
              <span className="material-symbols-outlined" aria-hidden="true">close</span>
            </button>
          </div>
          <EmojiPicker.Viewport className="emoji-viewport">
            <EmojiPicker.Loading><div className="emoji-note">Loading emojis...</div></EmojiPicker.Loading>
            <EmojiPicker.Empty><div className="emoji-note">No emoji found.</div></EmojiPicker.Empty>
            <EmojiPicker.List components={{ Emoji: EmojiButton, CategoryHeader, Row }} />
          </EmojiPicker.Viewport>
        </EmojiPicker.Root>
      </div>
    </div>,
    document.body
  );
};

export default EmojiPickerDialog;
